import { useMemo } from 'react';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getIsLoggedIn } from '@api/selectors/auth';
import { getMeUserSubscriptionTimeline } from '@api/selectors/subscription';
import useFreshGoalInfo from '@api/hooks/goal/useFreshGoalInfo';
import useParentContact from '@api/hooks/parentContact/useParentContact';
import {
  getGoalActiveSubscription,
  getShowParentContactPrompt,
  isParentProgressFloaterInWindow
} from './parentProgressFloaterUtils';

const useShouldShowParentProgressFloater = (goalUID?: string) => {
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const subscriptionTimeline = useMyInfo(getMeUserSubscriptionTimeline);
  const { goalInfo } = useFreshGoalInfo(goalUID);

  const { hasVerifiedParentContact, isLoading: isParentContactStatusLoading } =
    useParentContact();

  return useMemo(() => {
    if (!isLoggedIn || !goalUID || isParentContactStatusLoading) {
      return false;
    }

    if (hasVerifiedParentContact) {
      return false;
    }

    const showParentContactPrompt = getShowParentContactPrompt(goalInfo);

    if (!showParentContactPrompt) {
      return false;
    }

    const activeSubscription = getGoalActiveSubscription(
      subscriptionTimeline,
      goalUID
    );

    const startedAt = activeSubscription?.startedAt;
    const expiredAt = activeSubscription?.expiredAt;

    return isParentProgressFloaterInWindow(startedAt, expiredAt);
  }, [
    goalInfo,
    goalUID,
    hasVerifiedParentContact,
    isLoggedIn,
    isParentContactStatusLoading,
    subscriptionTimeline
  ]);
};

export default useShouldShowParentProgressFloater;
